module.exports = __webpack_public_path__ + "img/solution-7.58728ec1.jpg";